<script>
  try {
    parent.postMessage("surveysubmited", "*");
  } catch {
    return true;
  }
</script>
<script language="javascript" type="text/javascript">
  {
    {
      ThankYouMessage?.cusotomScript;
    }
  }
</script>

<div
  class="thankYouMsgWrapper survey-border"
  [ngClass]="{
    'full-survey-width': surveyWidthType == 3,
    'medium-survey-width': surveyWidthType == 2,
    'small-survey-width': surveyWidthType == 1,
    RTLDir: isRTL
  }"
>
  <img alt='' src="{{ thankYouGifURL }}" style="height: 1px; width: 1px; border-width: 0px; opacity: 1" />

  <div *ngIf="SurveyLogoImageUrl" class="survey-logo thank-you">
    <div
      [ngClass]="
        SurveyLogoAlign == 1
          ? 'align-l'
          : SurveyLogoAlign == 2
            ? 'align-c'
            : SurveyLogoAlign == 3
              ? 'align-r'
              : ''
      "
    >
      <app-image-control
        [imageName]="SurveyLogoImageUrl"
        [imagePath]="undefined"
        [imageRedirectURL]="undefined"
      >
      </app-image-control>
    </div>
  </div>
  <div
    class="clsThankYou image-center"
    [innerHTML]="
      (ThankYouMessage?.ThankyouPage ? ThankYouMessage?.ThankyouPage : '') | headerFooterHtml
    "
  ></div>

  <div class="offline-btns-wrapper clearfix1" style="text-align: center" *ngIf="isOfflineSurvey">
    <div
      *ngIf="OfflineResponseData.length <= 99"
      class="r-record-btn"
      style="margin: 0 auto"
      value="Start"
      (click)="RecordResponse()"
    >
      <div class="r-plus">+</div>
      Record New Response
    </div>

    <div
      class="r-upload r-home"
      style="float: none; display: inline-block; margin-top: 40px"
      value="Go Home"
      (click)="OfflineDashboard()"
    >
      <div class="r-upload-text">Return Home</div>
    </div>
  </div>

  <div *ngIf="ThankYouMessage.isThankYou == '0'" class="ResponseRecorded">
    <span> {{ ResponseRecorded }} </span>
  </div>

  <div id="mask" class=""></div>

  <div class="modalWindow" id="viralinvitepop" style="display: none" runat="server">
    <div [innerHTML]="ThankYouMessage?.viralinvitepop | headerFooterHtml"></div>
  </div>
</div>
<div
  *ngIf="ThankYouMessage?.ShowBtnContinue"
  [ngClass]="isMobile ? '' : 'navigation-band thank-you-wrapper-desk'"
>
  <div
    [ngStyle]="defaultBtnAlignWidth()"
    [ngClass]="{
      RTLDirICON: isRTL,
      'full-survey-width-footer':
        (surveyData?.SurveySettings.surveyWidthType === 3 || isTablet) && !isMobile,
      'medium-survey-width-footer':
        surveyData?.SurveySettings.surveyWidthType === 2 && !isTablet && !isMobile,
      'small-survey-width-footer':
        surveyData?.SurveySettings.surveyWidthType === 1 && !isTablet && !isMobile,
      'footerBtnSyled tblPageFooter': !isMobile,
      'footerBtnSyledMobile tblPageFooterMobile': isMobile,
      'btn-type-text': surveyData?.SurveyDetails?.ButtonType === 0,
      'btn-type-icon': surveyData?.SurveyDetails?.ButtonType === 1,
      'btn-type-iconText': surveyData?.SurveyDetails?.ButtonType === 2,
      'btn-style-outline': surveyData?.SurveyDetails?.ButtonStyle,
      'btn-style-filled': !surveyData?.SurveyDetails?.ButtonStyle,
      'btn-size-sm': surveyData?.SurveyDetails?.ButtonSize === 0,
      'btn-size-md': surveyData?.SurveyDetails?.ButtonSize === 1,
      'btn-size-lg': surveyData?.SurveyDetails?.ButtonSize === 2,
      'btn-position-leftRightEnd': surveyData?.SurveyDetails?.Position === 0,
      'btn-position-center': surveyData?.SurveyDetails?.Position === 1,
      'btn-position-left': surveyData?.SurveyDetails?.Position === 2,
      'btn-position-right': surveyData?.SurveyDetails?.Position === 3
    }"
  >
    <div [innerHTML]="ThankYouMessage?.ContinueThankyouMsgInfo | headerFooterHtml"></div>
  </div>
</div>

<div [hidden]="isPowredByClient" class="footer-div main-footer-div thank-you-footer">
  <div [innerHTML]="PoweredByText | headerFooterHtml"></div>
</div>

<div class="Plat_Alert_ThankYou Warning Plat_Alert_custom For_ThankYou" style="display: none">
  <span class="success"></span>
  <span class="spnMsg" [ngStyle]="{ 'text-align': IsMobile ? 'left' : 'unset' }"
    ><span [innerHTML]="ToasterMessageForPreview | headerFooterHtml" id="spnPreviewMsgToast"></span
  ></span>
  <span class="closebtn" id="close-btn-thankyou"></span>
</div>
